import { ArpSegment, ForecastConstant } from "models/UserArpsModel";

export enum ForecastWellStatus {
  Working = "working",
  Published = "published",
  Archived = "archived",
  Approved = "approved",
  PDPUpdated = "pdpUpdated",
  NotPDPUpdated = "notPDPUpdated",
  MissingForecast = "missingForecast"
}

export interface WellHierarchy {
  hierarchyName: string;
  key: string;
  title?: string;
  children: WellHierarchy[];
  selectable?: boolean;
  leafs: ForecastWell[];
}

export interface ForecastWell {
  entityName: string;
  key: string;
  title?: string;
  parentKey?: string;
  uwi: string;
  status: ForecastWellStatus;
  approved: boolean;
  created: Date;
  createdBy: string;
  selectable?: boolean;
  forecast?: {
    segments: ArpSegment[];
    arps: ArpSegment[];
    constants: ForecastConstant[];
  };
  hasErrors: boolean;
  hasWarnings: boolean;
  missingForecast?: boolean;
}

export interface WellHierarchyCollection {
  hierarchy: WellHierarchy[];
  leafs: ForecastWell[];
}

export interface ApplyTypeWellRequest {
  typeWell: {
    arps: ArpSegment[];
    constants: ForecastConstant[];
  };
  wells: string[];
}

export interface ApplyForecastRequest {
  sourceUwi: string;
  targetUwis: string[];
}

export interface ApplyForecastResponse {
  successCount: number;
  failedCount: number;
  failedWells?: string[];
  message: string;
}

export interface UpdateForecastWell {
  forecast: {
    segments: ArpSegment[];
    constants: ForecastConstant[];
    onTimeArray: OnTime[];
  };
  hasWarnings: boolean;
  hasErrors: boolean;
  approved?: boolean;
}

export interface OnTime {
  month: string;
  value: number;
}

export interface ForecastingChangeByRecord {
  id: string;
  email: string;
  fullName: string;
}

export interface ForecastingChangeRecord {
  id: string;
  changedBy: ForecastingChangeByRecord;
  changedDate: string;
  forecastId: string;
  comment: string;
  newForecast: {
    segments: ArpSegment[];
    constants: ForecastConstant[];
    onTimeArray: OnTime[];
  };
}

export const ForecastWellStatusFilterOptions = [
  { label: "Missing Forecast", value: ForecastWellStatus.MissingForecast }, // maps to leaf.missingForecast
  { label: "Working", value: ForecastWellStatus.Working },
  { label: "PDP Updated", value: ForecastWellStatus.PDPUpdated }, // maps to leaf.approved
  { label: "Not PDP Updated", value: ForecastWellStatus.NotPDPUpdated }, // maps to !leaf.approved
  { label: "Published", value: ForecastWellStatus.Published }
];
